<template>
  <div>
    <div class="title">注册</div>
    <div v-if="success" style="padding-top: 100px;">
      <p
        style="font-size: 30px;
    text-align: center;
    color: #f0ba1c;
    line-height: 100px;"
      >注册成功</p>
      <div style="text-align: center;">
        <el-button type="success" @click="login">去登录</el-button>
      </div>
    </div>
    <div class="box" v-else>
      <div class="item">
        <span class="label importLabel">选择成员：</span>
        <el-select
          class="input"
          size="medium"
          @change="blurInput('organId','成员')"
          placeholder="请输入关键词"
          v-model="organId"
          filterable
          remote
          :remote-method="remoteMethod"
        >
          <el-option
            v-for="item in organList"
            :label="item.organName"
            :value="item.id"
            :key="item.id"
          >{{item.organName}}</el-option>
        </el-select>
        <span v-if="organIdError" class="error">{{organIdError}}</span>
      </div>
      <div class="item">
        <span class="label importLabel">用户昵称：</span>
        <el-input
          class="input"
          @blur="blurInput('userCode','用户昵称')"
          size="medium"
          v-model="userCode"
          placeholder="请输入用户昵称"
        ></el-input>
        <span v-if="userCodeError" class="error">{{userCodeError}}</span>
      </div>
      <div class="item">
        <span class="label importLabel">用户姓名：</span>
        <el-input
          class="input"
          @blur="blurInput('userName','用户姓名')"
          size="medium"
          v-model="userName"
          placeholder="请输入用户姓名"
        ></el-input>
        <span v-if="userNameError" class="error">{{userNameError}}</span>
      </div>
      <div class="item">
        <span class="label importLabel">用户性别：</span>
        <el-radio v-model="sex" label="M">男</el-radio>
        <el-radio v-model="sex" label="F">女</el-radio>
      </div>

      <div class="item">
        <span class="label importLabel">所属部门：</span>
        <el-select
          class="input"
          size="medium"
          @change="blurInput('departmentId','所属部门')"
          placeholder="请选择"
          v-model="departmentId"
        >
          <el-option
            v-for="item in findDepartment"
            :label="item.departmentName"
            :value="item.departmentId"
            :key="item.departmentId"
          >{{item.departmentName}}</el-option>
        </el-select>
        <span v-if="departmentIdError" class="error">{{departmentIdError}}</span>
      </div>

      <div class="item">
        <span class="label importLabel">手机号码：</span>
        <el-input
          class="input"
          @blur="blurInput('mobileCode','手机号码')"
          size="medium"
          v-model="mobileCode"
          placeholder="请输入手机号码"
        ></el-input>
        <span v-if="mobileCodeError" class="error">{{mobileCodeError}}</span>
      </div>
      <div class="item">
        <span class="label importLabel">电子邮箱：</span>
        <el-input
          class="input"
          @blur="blurInput('email','电子邮箱')"
          size="medium"
          v-model="email"
          placeholder="请输入邮箱"
        ></el-input>
        <span v-if="emailError" class="error">{{emailError}}</span>
      </div>
      <div class="item">
        <span class="label importLabel">登录密码：</span>
        <el-input
          class="input"
          @blur="checkPassword"
          size="medium"
          v-model="password"
          show-password
          placeholder="请输入密码"
        ></el-input>
        <span v-if="passwordError" class="error">{{passwordError}}</span>
      </div>
      <div class="item">
        <span class="label importLabel">确认密码：</span>
        <el-input
          @blur="checkPassword2"
          class="input"
          size="medium"
          v-model="password2"
          show-password
          placeholder="请再次输入密码"
        ></el-input>
        <span v-if="password2Error" class="error">{{password2Error}}</span>
      </div>
      <div class="submin">
        <el-button type="primary" @click="save">注册</el-button>
        <el-button style="margin-left:50px;" @click="back">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { organ_qy, student_qy, student_opt, user_opt } from "@/api/home";
export default {
  data() {
    return {
      sex: "M",
      mobileCode: undefined,
      mobileCodeError: "",
      emailError: "",
      email: undefined,
      passwordError: "",
      password2Error: "",
      password: undefined,
      password2: undefined,
      userName: undefined,
      userNameError: undefined,
      userCode: undefined,
      userCodeError: undefined,
      organId: undefined,
      departmentId: undefined,
      departmentIdError: "",
      organIdError: "",
      success: false,

      codeError: "",
      nameError: "",

      studentCode: null,
      value: null,
      mineStatus: {},
      treedata: [],
      defaultProps: {
        children: "chdList",
        label: "organName"
      },
      userObj: {
        classes: {}
      },
      organList: [],
      findDepartment: []
    };
  },
  mounted() {
    this.add();
    organ_qy({ op: "findPageFirstLayerOrgan" }).then(res => {
      this.organList = res.result;
    });
  },
  methods: {
    remoteMethod(val) {
      organ_qy({ op: "findPageFirstLayerOrgan", retrieveArg: val }).then(
        res => {
          this.organList = res.result;
        }
      );
    },
    getFindDepartment() {
      organ_qy({ op: "findDepartmentByOrganId", organId: this.organId }).then(
        res => {
          this.findDepartment = res;
        }
      );
    },
    blurInput(str, name, boo) {
      let reg = /(^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+)|(^$)/;
      if (str == "organId" && !boo) {
        this.departmentId = undefined;
        this.getFindDepartment();
      }

      if (!this[str] && this[str] !== 0) {
        this[str + "Error"] = name + "不能为空";
        return false;
      } else if (str == "email" && !reg.test(this.email)) {
        this[str + "Error"] = name + "格式有误";
        return false;
      } else {
        this[str + "Error"] = "";
        return true;
      }
    },
    login() {
      this.$router.push({
        path: "/login"
      });
    },
    checkPassword2() {
      if (!this.password2) {
        this.password2Error = "请再次输入密码";
        return false;
      }
      if (this.password !== this.password2) {
        this.password2Error = "两次密码不一致";
        return false;
      } else {
        this.password2Error = "";
        return true;
      }
    },
    checkPassword() {
      if (!this.password) {
        this.passwordError = "密码不能为空";
        return false;
      }
      if (this.password.length < 6) {
        this.passwordError = "密码长度不能小于6个字符";
        return false;
      } else {
        this.passwordError = "";
        return true;
      }
    },
    checkCode() {
      if (!this.studentCode) {
        this.codeError = "学籍号码不能为空";
        return false;
      } else {
        this.codeError = "";
        return true;
      }
    },
    checkValue() {
      if (!this.value) {
        this.nameError = "学校名称不能为空";
        return false;
      } else {
        this.nameError = "";
        return true;
      }
    },
    checkEmail() {
      let reg = /(^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+)|(^$)/;
      if (!this.email) {
        this.emailError = "电子邮箱不能为空";
        return false;
      }
      if (reg.test(this.email)) {
        this.emailError = "";
        return true;
      } else {
        this.emailError = "电子邮箱格式有误";
        return false;
      }
    },
    checkMobileCode() {
      let reg = /(^1\d{10}$)/;
      if (!this.mobileCode) {
        this.mobileCodeError = "手机号码不能为空";
        return false;
      }
      if (reg.test(this.mobileCode)) {
        this.mobileCodeError = "";
        return true;
      } else {
        this.mobileCodeError = "手机号码格式有误";
        return false;
      }
    },
    add() {
      user_opt({ op: "add" }).then(res => {});
    },
    save() {
      let success = true;
      success = this.blurInput("organId", "成员", true) ? success : false;
      success = this.blurInput("userCode", "用户昵称") ? success : false;
      success = this.blurInput("userName", "用户姓名") ? success : false;
      success = this.blurInput("departmentId", "所属部门") ? success : false;
      success = this.blurInput("mobileCode", "手机号码") ? success : false;
      success = this.blurInput("email", "电子邮箱") ? success : false;
      let checkPassword = this.checkPassword();
      let checkPassword2 = this.checkPassword2();
      if (!success) {
        this.$message.error("注册信息填写有误请检查！");
        return;
      }
      if (checkPassword && checkPassword2) {
        const data = {};
        data["organ.organId"] = this.organId;
        data.userCode = this.userCode;
        data.userName = this.userName;
        data["department.departmentId"] = this.departmentId;
        data.mobileCode = this.mobileCode;
        data.email = this.email;
        data.sex = this.sex;
        data.userPassword = this.password;
        user_opt({ op: "save", ...data }).then(res => {
          if (res.success) {
            this.success = true;
          } else {
            this.$message.error(res.msg);
          }
          console.log(res);
        });
        console.log(111111);
      }
    },
    back() {
      window.history.back(-1);
    },
    studentCodeChange(val) {
      this.getCode();
    },
    handleCheckChange(val) {
      this.mineStatus = {
        value: val.organId,
        label: val.organName
      };
      this.value = val.organId;
      this.nameError = "";
      if (this.studentCode) {
        this.getCode();
      }
    },
    getTree() {
      organ_qy({ op: "findCollege" }).then(res => {
        this.treedata = res;
      });
    },
    getCode() {
      if (!this.value) {
        this.$message({
          message: "请选择学校",
          type: "warning"
        });
        return;
      }
      if (!this.studentCode) {
        this.$message({
          message: "请输入学籍号码",
          type: "warning"
        });
        return;
      }
      student_qy({
        op: "getStudentTemplateByCode",
        collegeId: this.mineStatus.value,
        studentCode: this.studentCode
      }).then(res => {
        if (!res) {
          this.codeError = "请输入正确的学籍号码";
        } else {
          this.codeError = "";
        }

        this.userObj = res || { classes: {} };
      });
    }
  }
};
</script>

<style lang="less" scoped>
.title {
  text-align: center;
  font-size: 35px;
  line-height: 100px;
  display: none;
}
.box {
  width: 500px;
  margin: 50px auto;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 0 15px 2px #ddd;
  .label {
    line-height: 40px;
    font-size: 14px;
  }
  .item {
    margin-bottom: 14px;
    position: relative;
    .error {
      position: absolute;
      right: 12px;
      font-size: 12px;
      bottom: -14px;
      color: red;
    }
  }
  .input {
    width: 350px;
  }
  .submin {
    text-align: center;
    padding-top: 10px;
  }
}
li {
  padding: 0 20px;
}
</style>